import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { SequenceMenu } from '@sequencehq/core-components'
import { useNotifications } from '@sequencehq/core-components'
import { usePermissions } from 'lib/rbac'

export const useCreateTemplateFromQuote = (props: {
  quoteId: string
  onSuccess?: (newQuoteTemplateId: string) => void
}) => {
  const { displayPromiseNotification } = useNotifications()

  return {
    createTemplateFromQuote: async () => {
      try {
        const newTemplateRes = await displayPromiseNotification(
          dashboard20240730Client.postCreateQuoteTemplateFromQuote({
            id: props.quoteId
          }),
          {
            loading: 'Creating template from quote',
            success: 'Template created',
            error: 'Failed to create template'
          }
        )

        if (newTemplateRes.error || !newTemplateRes.data?.template?.id) {
          return false
        }

        props.onSuccess?.(newTemplateRes.data.template.id)
        return true
      } catch {
        return false
      }
    },
    creationInProgress: false
  }
}

export const CreateTemplateFromQuoteMenuItem = (props: {
  quoteId: string
  disabled?: boolean
  disabledReason?: string
  onSuccess?: (newQuoteTemplateId: string) => void
}) => {
  const { createTemplateFromQuote } = useCreateTemplateFromQuote({
    quoteId: props.quoteId,
    onSuccess: props.onSuccess
  })

  const { can } = usePermissions()

  if (!can('org.quote:template.update')) {
    return null
  }

  return (
    <SequenceMenu.Item
      uuid="create-template-from-quote"
      label="Save as template"
      data-testid={`quotes.${props.quoteId}.menuItem.createTemplate`}
      isDisabled={props.disabled}
      tooltip={props.disabledReason}
      onClick={createTemplateFromQuote}
    />
  )
}
